/**
 * Dropdowns for submenu items and search box in header
 *
 */
'use strict';

(function() {
	const hamburgerToggle = document.getElementById('hamburger-toggle');
	const body = document.body;
	const stickyToggle = document.querySelector('.hamburger-toggle-sticky');
	const narrowMenuContainer = document.querySelector('.narrow-menu-container');

	let menuOpen = false;

	// bail if no toggles or containers
	if (!hamburgerToggle) {
		return;
	}

	// Handler to open and close the mobile menu
	function toggleMenuOpen() {
		body.classList.toggle('mobile-menu-open');
		menuOpen = !menuOpen;
		toggleAria( menuOpen, this );
	}

	// Close the dropdown and reset classes and attributes
	function closeMenu() {
		body.classList.toggle('mobile-menu-open');
		menuOpen = !menuOpen;
		toggleAria( menuOpen, this );
	}

	// Handle an ESC close via the keyboard
	function escCloseForm(e) {
		if (menuOpen) {
			if (27 === e.keyCode) {
				closeMenu();
			}
		}
	}

	// Toggle aria expanded attribute.
	function toggleAria( menuOpen, button ) {
		if ( button ) {
			button.setAttribute( 'aria-expanded', menuOpen );
		} else {
			// Probably used the keyboard to close the menu.
			hamburgerToggle.setAttribute( 'aria-expanded', menuOpen );
			stickyToggle.setAttribute( 'aria-expanded', menuOpen );
		}
	}

	function closeOnShift(e) {
		if (menuOpen && ! narrowMenuContainer.contains(document.activeElement) && hamburgerToggle !== document.activeElement) {
			if (!e.shiftKey && 9 === e.keyCode) {
				closeMenu();
			}
		}
	}

	function closeOnShiftTab(e) {
		if (menuOpen && ! narrowMenuContainer.contains(document.activeElement)) {
			if (e.shiftKey && 9 === e.keyCode) {
				closeMenu();
			}
		}
	}

	hamburgerToggle.addEventListener('click', toggleMenuOpen);
	stickyToggle.addEventListener('click', toggleMenuOpen);

	/**
	 * Listen for esc key when menu is open
	 */
	window.addEventListener('keydown', escCloseForm);

	/**
	 * Listen for shift key when menu is open
	 */
	window.addEventListener('keydown', closeOnShift);

	/**
	 * Listen for shift tab key when menu is open
	 */
	window.addEventListener('keydown', closeOnShiftTab);
})();
